import React from 'react';
import { AppBar, Box, Button, Stack, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { useT } from '../localization/LocalizationProvider';

const navItems = [
  { labelKey: 'Common.Dashboard', to: '/admin/dashboard' },
  { labelKey: 'Admin.Layout.Nav.GameSettings', to: '/admin/postavke-igre' },
  { labelKey: 'Admin.Layout.Nav.Questions', to: '/admin/pitanja' },
  { labelKey: 'Admin.Layout.Nav.Quizzes', to: '/admin/kvizovi' },
  { labelKey: 'Admin.Layout.Nav.GlobalSettings', to: '/admin/opce-postavke' }
];

export function AdminLayout() {
  const t = useT();
  const location = useLocation();

  return (
    <>
      <AppBar position="static">
        <Toolbar sx={{ flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>{t('Admin.Layout.Title')}</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {navItems.map((item) => (
              <Button
                key={item.to}
                component={RouterLink}
                to={item.to}
                color="inherit"
                variant={location.pathname === item.to ? 'outlined' : 'text'}
                sx={{ borderColor: 'rgba(255,255,255,0.5)' }}
              >
                {t(item.labelKey)}
              </Button>
            ))}
          </Stack>
        </Toolbar>
      </AppBar>
      <Box sx={{ py: 3 }}><Outlet /></Box>
    </>
  );
}
